<template>
  <div>
  <vs-dropdown>

    <div class="flex items-center" href="#">
      Features
      <i class="material-icons"> expand_more </i>
    </div>

    <vs-dropdown-menu>

      <vs-dropdown-item>
        Feature 1
      </vs-dropdown-item>

      <vs-dropdown-item>
        Feature 2
      </vs-dropdown-item>

      <vs-dropdown-item>
        Feature 3
      </vs-dropdown-item>

    </vs-dropdown-menu>
  </vs-dropdown>
  </div>
</template>

<script>
    export default {
        name: "Features"
    }
</script>

<style scoped>

</style>
